import api from '@/utils/api';
import {
    GET_PROJECT_JOBS,
    GET_PROJECT_JOB,
    UPDATE_PROJECT_JOB,
    CREATE_PROJECT_JOB,
    REMOVE_PROJECT_JOBS,
    UPDATE_PROJECT_JOB_RESULT,
    UPDATE_PROJECT_JOB_STATUS,
    ASSIGN_PROJECT_JOBS
} from './types';
import { NotificationManager } from 'react-notifications';

const showRequestError = (error) => {
    NotificationManager.error(error.response?.data?.msg || 'Đã xảy ra lỗi, vui lòng thử lại.');
};

export const getProjectJobs = filter => dispatch => api
    .get('/project-jobs', { params: filter })
    .then(response => {
        dispatch({ type: GET_PROJECT_JOBS, payload: response.data.data });
        return response.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

export const createProjectJob = data => dispatch => api
    .post('/project-jobs', data)
    .then(response => {
        dispatch({ type: CREATE_PROJECT_JOB, payload: response.data.data });
        NotificationManager.success('Thêm mới bản ghi thành công!');
        return response.data.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

export const getProjectJob = id => dispatch => api
    .get(`/project-jobs/${id}`)
    .then(response => {
        dispatch({ type: GET_PROJECT_JOB, payload: response.data.data });
        return response.data.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

export const updateProjectJob = (id, data) => dispatch => api
    .put(`/project-jobs/${id}`, data)
    .then(response => {
        dispatch({ type: UPDATE_PROJECT_JOB, payload: response.data.data });
        NotificationManager.success('Cập nhật bản ghi thành công!');
        return response.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

export const updateProjectJobResult = (id, data) => dispatch => api
    .put(`/project-jobs/update-result/${id}`, data)
    .then(response => {
        dispatch({ type: UPDATE_PROJECT_JOB_RESULT, payload: response.data.data });
        NotificationManager.success('Cập nhật bản ghi thành công!');
        return response.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

export const updateProjectJobStatus = (id, data) => dispatch => api
    .put(`/project-jobs/update-status/${id}`, data)
    .then(response => {
        dispatch({ type: UPDATE_PROJECT_JOB_STATUS, payload: response.data.data });
        NotificationManager.success('Cập nhật bản ghi thành công!');
        return response.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

export const removeProjectJobs = ids => dispatch => api
    .delete('/project-jobs', { data: { ids } })
    .then(response => {
        dispatch({ type: REMOVE_PROJECT_JOBS, payload: ids });
        NotificationManager.success('Xoá bản ghi thành công!');
        return response.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

export const assignProjectJobs = (ids, data) => dispatch => api
    .post('/project-jobs/assign', { ids, data })
    .then(response => {
        dispatch({ type: ASSIGN_PROJECT_JOBS, payload: response.data.data });
        NotificationManager.success(response.data.msg);
        return response.data;
    })
    .catch(error => {
        showRequestError(error);
        return Promise.reject(error);
    });

